import type { OtpChannel } from '@Common/types/auth/otp_channel';

export class TwoFactorRequired extends Error {
  public readonly email: string;
  public readonly trustDevice: boolean;
  public readonly otpChannel: OtpChannel;

  constructor(email: string, trustDevice: boolean, otpChannel: OtpChannel) {
    super('Two Factor authentication required');
    this.email = email;
    this.trustDevice = trustDevice;
    this.otpChannel = otpChannel;
  }
}
